export default "/images/image_9.jpg?c20d3cfeba04d2336a30ecbe8519af5e";